import React from "react";
import { Text, View } from "react-native";
import DateTimeComponent from "../ongoing-common-components/schedule-components/DateTimeComponent";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import DateTimeWalkthrough from "../walk-through-common-components/createEventTooltips/DateTimeWalkthrough";

const SchedulingEventComponent = ({
  selectTime,
  setSelectTime,
  selectDate,
  setSelectDate,
  setShowDatePicker,
  scrollViewRef = null,
}) => {
  const styles = useStyles();
  return (
    <View style={{ zIndex: -1 }}>
      <DateTimeWalkthrough scrollViewRef={scrollViewRef} />

      <View style={styles.mainInputWrapper}>
        {/* Select date */}

        <DateTimeComponent
          index={1}
          title=""
          styles={styles}
          setShowDatePicker={setShowDatePicker}
          setSelectDate={setSelectDate}
          selectDate={selectDate}
          setSelectTime={setSelectTime}
          selectTime={selectTime}
          type="createEvent"
          dateTitle="Select date"
          timeTitle="Select time"
        />
      </View>
    </View>
  );
};

export default SchedulingEventComponent;

const useStyles = CreateResponsiveStyle(
  {
    mainInputWrapper: {
      flexDirection: "row",
      gap: 25,
    },
    inputWrapper: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
      minHeight: 50,
      justifyContent: "center",
    },
    deviceflexDirection: {
      flexDirection: "row",
      gap: 10,
    },
    viewStyle: {
      flex: 0.5,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainInputWrapper: {
        flexDirection: "row",
        gap: 25,
      },
    },
    [DEVICE_SIZES.MD]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      inputWrapper: {
        flex: 1,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      viewStyle: {
        flex: 1,
      },
    },

    [DEVICE_SIZES.XS]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      inputWrapper: {
        flex: 1,
      },
      deviceflexDirection: {
        flexDirection: "column",
      },
      viewStyle: {
        flex: 1,
      },
    },
  }
);
